import React from 'react'
import { styled } from '@mui/material'
const Styled = styled('div')`
    align-items: center;
    background-image: url('/images/home/imagessale.png'), url('/images/home/favpng_social-media-marketing-insurance-service-sales.png');
    background-repeat: no-repeat;
    background-position: left top, right top;
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin: auto;
    text-align: center;
    background-size: contain;
    height: 73px;
    background-size: 80px;
    width: 100%;
    position: absolute;
    top: 0px;
    display: none;
    ${({ theme }) => theme.breakpoints.up('lg')} {
        background-image: url('/images/home/imagessale.png'), url('/images/home/favpng_social-media-marketing-insurance-service-sales.png');
        background-position: left center, right center;
        height: 408px;
        background-size: 190px;
        top: -8px;
    }
    z-index: 0;
`
const NPCForm: React.FC = () => {
    return <Styled />
}
export default NPCForm
